__turbopack_context__.v({
  "current": "price-module-scss-module__x5iJMq__current",
  "old": "price-module-scss-module__x5iJMq__old",
});
